import type { StatusTone } from '@/types/domain'

export interface IndicadorPorCodigo {
  codigo: string
  quantidade: number
}

export interface IndicadoresDashboard {
  concluidas: number | null
  emAndamento: number | null
  precisamDeAtencao: number | null
  canceladas: number | null
  porCodigo: IndicadorPorCodigo[]
}

export const indicadoresDashboardVazio: IndicadoresDashboard = {
  concluidas: null,
  emAndamento: null,
  precisamDeAtencao: null,
  canceladas: null,
  porCodigo: [],
}

export const FAMILIA_INDICADOR = {
  Concluidas: 'Concluidas',
  EmAndamento: 'EmAndamento',
  PrecisamDeAtencao: 'PrecisamDeAtencao',
  Canceladas: 'Canceladas',
} as const

export type FamiliaIndicador = (typeof FAMILIA_INDICADOR)[keyof typeof FAMILIA_INDICADOR]

export const familiaIndicadorMeta: Record<FamiliaIndicador, string> = {
  Concluidas: 'Autorizações concluídas',
  EmAndamento: 'Guias em andamento',
  PrecisamDeAtencao: 'Precisam de atenção',
  Canceladas: 'Cancelamentos',
}

export const ESTADO_SAUDE_PRODUTO = {
  Online: 'Online',
  Instavel: 'Instavel',
  Offline: 'Offline',
  SemMonitoramento: 'SemMonitoramento',
} as const

export type EstadoSaudeProduto = (typeof ESTADO_SAUDE_PRODUTO)[keyof typeof ESTADO_SAUDE_PRODUTO]

export interface EstadoSaudeMeta {
  label: string
  tone: StatusTone
}

export const estadoSaudeProdutoMeta: Record<EstadoSaudeProduto, EstadoSaudeMeta> = {
  Online: { label: 'Online', tone: 'success' },
  Instavel: { label: 'Instável', tone: 'warning' },
  Offline: { label: 'Offline', tone: 'danger' },
  SemMonitoramento: { label: 'Sem monitoramento', tone: 'neutral' },
}

export interface SaudeProduto {
  produto: string
  estado: EstadoSaudeProduto
  ultimaVerificacaoUtc: string | null
  latenciaMs: number | null
}

export const produtoDashboardLabel: Record<string, string> = {
  Crawler: 'Crawler',
  ApiClient: 'Api Client',
  ApiBackoffice: 'Api Backoffice',
  WebApp: 'Web App',
  Extensao: 'Extensão',
  WebJobs: 'Web Jobs',
}

export interface FiltroListagemAlerta {
  clienteId: string | null
  operadoraId: string | null
  credencialId: string | null
  situacoes: string[] | null
  dataInicial: string | null
  dataFinal: string | null
}

export interface AlertaDashboard {
  tipo: string
  severidade: string
  titulo: string
  descricao: string
  entidadeTipo: string | null
  entidadeId: string | null
  entidadeNome: string | null
  quantidade: number
  filtro: FiltroListagemAlerta
}

export const severidadeAlertaTone: Record<string, StatusTone> = {
  Alta: 'danger',
  Media: 'warning',
}

export interface PreferenciaIndicadoresPayload {
  perfil: string
  familias: FamiliaIndicador[]
}
